import {LogoBrand} from './LogoBrand.tsx';
import {Contours} from './Ornaments.tsx';
import {ChipTone, type BankCardSkin} from './types.ts';

function Face() {
    return (
        <>
            <div className="absolute inset-0 bg-[radial-gradient(80%_110%_at_92%_0%,rgba(64,169,214,0.28)_0%,transparent_70%),linear-gradient(155deg,#124A6E_0%,#0B3553_55%,#062238_100%)]" />
            <Contours color="#9FD6EE" opacity={0.14} />
        </>
    );
}

export const knabSkin: BankCardSkin = {
    Face,
    Brand: LogoBrand,
    chipTone: ChipTone.Silver,
    hasMastercard: false,
    surfaceTone: 'dark',
    contentColor: '#FFFFFF',
    labelColor: 'rgba(255, 255, 255, 0.72)',
    contactlessColor: 'rgba(255, 255, 255, 0.8)',
    mastercardWordColor: 'rgba(255, 255, 255, 0.85)',
};
